import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import {
  APQueryOptions,
  SHORT_STALE_TIME,
} from "../../providers/APQueryProvider";

export const getApiVersion = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();

  return useQuery({
    queryKey: ["api-version"],
    queryFn: (): Promise<string> => {
      return fetchWithAuth<string>("getApiVersion");
    },
    staleTime: SHORT_STALE_TIME,
    refetchInterval: options.refetchInterval,
  });
};
